import { createContext, useContext } from "react";
import { ActorRefFrom } from "xstate";
import { signupMachine } from "../machines/signup.control.machine";

// Define the type for the context value (the machine's actor reference)
type SignUpMachineContextType = ActorRefFrom<typeof signupMachine> | null;

export const SignUpMachineContext =
  createContext<SignUpMachineContextType>(null);

export const useSignUpMachine = () => {
  const context = useContext(SignUpMachineContext);
  if (!context) {
    throw new Error(
      "useSignUpMachine must be used within a SignUpMachineContext",
    );
  }
  return context;
};
